"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _superSegments = require("../../reducers/superSegments");

var _actions = require("../../actions");

var _index = require("../../../index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GenerateAdsGoogleMockup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GenerateAdsGoogleMockup, _React$Component);

  function GenerateAdsGoogleMockup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // Set Default State

    _defineProperty(_assertThisInitialized(_this), "handleSetHeadline", function (newHeadlineId) {
      _this.setState({
        currentHeadline: newHeadlineId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetDescription", function (newDescriptionId) {
      _this.setState({
        currentDescription: newDescriptionId
      });
    });

    _this.state = {
      headlines: [],
      descriptions: [],
      currentHeadline: 0,
      currentDescription: 0,
      company: '',
      url: ''
    };

    if (props.results) {
      if (props.results.headlines && props.results.headlines.length > 0) {
        _this.state.headlines = props.results.headlines;
      }

      if (props.results.descriptions && props.results.descriptions.length > 0) {
        _this.state.descriptions = props.results.descriptions;
      }
    }

    _this.state.company = props.data && props.data.company ? props.data.company : '';
    _this.state.url = props.data && props.data.url ? props.data.url : '';
    return _this;
  }

  var _proto = GenerateAdsGoogleMockup.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        currentHeadline = _this$state.currentHeadline,
        currentDescription = _this$state.currentDescription,
        headlines = _this$state.headlines,
        descriptions = _this$state.descriptions,
        company = _this$state.company,
        url = _this$state.url;
    var isLoaded = headlines.length > 0 && descriptions.length > 0 ? true : false;
    var buttonNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // Define style variables

    var resultStyle = {
      display: 'flex',
      width: '485px',
      padding: '24px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '10px',
      background: '#FFF'
    };
    var sponsoredText = {
      color: '#202124',
      fontFamily: 'Arial',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '12px' // You can use a string for this value

    };
    var headerStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    };
    var faviconStyle = {
      width: '23px',
      height: '23px',
      background: '#EDEEF0',
      borderRadius: '11.5px'
    };
    var siteInfoStyle = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gape: '4px'
    };
    var siteTitleStyle = {
      color: '#4D5156',
      fontFamily: 'Arial',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '12px'
    };
    var siteUrlStyle = {
      color: '#4D5156',
      fontFamily: 'Arial',
      fontSize: '10px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '12px'
    };
    var headlineStyle = {
      display: 'flex',
      width: '435px',
      height: '16px',
      flexDirection: 'column',
      justifyContent: 'center',
      textDecoration: 'none',
      overflow: 'hidden',
      color: '#1A0DAB',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontFamily: 'Arial',
      fontSize: '17px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '12px' // You can use a string for this value

    };
    var descriptionStyle = {
      display: 'flex',
      width: '435px',
      height: '30px',
      flexDirection: 'column',
      justifyContent: 'center',
      overflow: 'hidden',
      color: '#4D5156',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontFamily: 'Arial',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '15px' // You can use a string for this value

    };
    var mockupWrapper = {
      width: '100%'
    };
    var headerMockup = {
      alignSelf: 'stretch',
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '25.6px' // You can use a string for this value

    };
    var subtitleStyle = {
      display: 'flex',
      width: '236px',
      height: '26px',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '25.6px'
    };
    var selectMenuList = {
      display: 'block',
      marginBottom: '20px'
    };
    var selectionMenuItem = {
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '4px',
      background: 'none'
    };
    var activeMenuItem = {
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '4px',
      background: '#00ACCA',
      color: '#fff'
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, isLoaded ? /*#__PURE__*/React.createElement("div", {
      className: "google-ad-mockup__wrapper",
      style: mockupWrapper
    }, /*#__PURE__*/React.createElement("h2", {
      style: headerMockup
    }, "Google MockUp"), /*#__PURE__*/React.createElement("div", {
      className: "mockup-section__headline",
      style: selectMenuList
    }, /*#__PURE__*/React.createElement("p", {
      style: subtitleStyle
    }, "Select Headline"), /*#__PURE__*/React.createElement("div", {
      className: "headline__button-list"
    }, buttonNumbers.map(function (buttonNumber, key) {
      return /*#__PURE__*/React.createElement("button", {
        key: key,
        onClick: function onClick() {
          return _this2.handleSetHeadline(key);
        },
        style: currentHeadline === key ? activeMenuItem : selectionMenuItem,
        className: "headline__list-item"
      }, buttonNumber);
    }))), /*#__PURE__*/React.createElement("div", {
      className: "mockup-section__headline",
      style: selectMenuList
    }, /*#__PURE__*/React.createElement("p", {
      style: subtitleStyle
    }, "Select Description"), /*#__PURE__*/React.createElement("div", {
      className: "mockup-section__description",
      style: selectMenuList
    }, buttonNumbers.map(function (buttonNumber, key) {
      return /*#__PURE__*/React.createElement("button", {
        key: key,
        onClick: function onClick() {
          return _this2.handleSetDescription(key);
        },
        style: currentDescription === key ? activeMenuItem : selectionMenuItem,
        className: "description__list-item"
      }, buttonNumber);
    }))), /*#__PURE__*/React.createElement("div", {
      style: resultStyle
    }, /*#__PURE__*/React.createElement("span", {
      style: sponsoredText
    }, "Sponsored"), /*#__PURE__*/React.createElement("div", {
      style: headerStyle
    }, /*#__PURE__*/React.createElement("div", {
      style: faviconStyle
    }), /*#__PURE__*/React.createElement("div", {
      style: siteInfoStyle
    }, /*#__PURE__*/React.createElement("span", {
      style: siteTitleStyle
    }, company), /*#__PURE__*/React.createElement("span", {
      style: siteUrlStyle
    }, url))), /*#__PURE__*/React.createElement("a", {
      href: url,
      style: headlineStyle
    }, headlines[currentHeadline]), /*#__PURE__*/React.createElement("p", {
      style: descriptionStyle
    }, descriptions[currentDescription]))) : '');
  };

  return GenerateAdsGoogleMockup;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    formLoading: state.superSegments.formLoading,
    communityImages: (0, _superSegments.getCommunityImages)(state),
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    firstLandingPage: state.campaignCreator.options.firstLandingPage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GenerateAdsGoogleMockup);

exports["default"] = _default;